<template>
  <div class="prospeccao-extras-wrapper">
    <!-- Switches: Metodologia + Utilitário + Veículo -->
    <div
      class="border border-grey-light rounded-lg px-6 py-4 prospeccao-extras-controls"
    >
      <!-- Metodologia -->
      <div class="flex flex-col gap-1">
        <label class="ft-label">Metodologia:</label>
        <div class="flex gap-6">
          <div class="flex flex-col items-center gap-1">
            <span class="ft-switch-label">FOG</span>
            <vs-switch
              v-model="fogAtivo"
              color="success"
              @input="onFogChange"
            />
          </div>
          <div class="flex flex-col items-center gap-1">
            <span class="ft-switch-label">UBV</span>
            <vs-switch
              v-model="ubvAtivo"
              color="success"
              @input="onUbvChange"
            />
          </div>
        </div>
      </div>

      <div
        class="w-px self-stretch bg-grey-light mx-2 prospeccao-divider"
      ></div>

      <!-- Utilitário -->
      <div class="flex flex-col gap-1">
        <label class="ft-label">Utilitário:</label>
        <div class="flex flex-col items-center gap-1">
          <span class="ft-switch-label">Escada</span>
          <vs-switch
            v-model="escadaAtivo"
            color="success"
            @input="onEscadaChange"
          />
        </div>
      </div>

      <div
        class="w-px self-stretch bg-grey-light mx-2 prospeccao-divider"
      ></div>

      <!-- Veículo -->
      <div class="flex flex-col items-center gap-1">
        <label class="ft-label">Veículo:</label>
        <span
          :class="temEquipamento ? 'text-blue-600' : 'text-purple-600'"
          :title="
            temEquipamento
              ? 'Carro — usado quando há FOG, UBV ou Escada no serviço'
              : 'Moto — usado quando não há equipamentos especiais'
          "
          class="cursor-pointer transition-transform hover:scale-110"
        >
          <template v-if="temEquipamento">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#64748b"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"
              />
              <circle cx="7" cy="17" r="2" />
              <path d="M9 17h6" />
              <circle cx="17" cy="17" r="2" />
            </svg>
          </template>
          <template v-else>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#64748b"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m18 14-1-3" />
              <path d="m3 9 6 2a2 2 0 0 1 2-2h2a2 2 0 0 1 1.99 1.81" />
              <path
                d="M8 17h3a1 1 0 0 0 1-1 6 6 0 0 1 6-6 1 1 0 0 0 1-1v-.75A5 5 0 0 0 17 5"
              />
              <circle cx="19" cy="17" r="3" />
              <circle cx="5" cy="17" r="3" />
            </svg>
          </template>
        </span>
      </div>
    </div>

    <!-- Legenda responsiva -->
    <div
      class="border border-grey-light rounded-lg px-4 py-3 prospeccao-extras-legenda legenda-hidden-sm"
    >
      <legendas-forca-trabalho-prospeccao-responsive class="w-full" />
    </div>
  </div>
</template>

<script>
import LegendasForcaTrabalhoProspeccaoResponsive from "./legendas-forca-trabalho-prospeccao-responsive.vue";

export default {
  name: "ProspeccaoExtras",

  components: {
    LegendasForcaTrabalhoProspeccaoResponsive,
  },

  props: {
    contrato: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      fogAtivo: false,
      ubvAtivo: false,
      escadaAtivo: false,
    };
  },

  computed: {
    temEquipamento() {
      return this.fogAtivo || this.ubvAtivo || this.escadaAtivo;
    },
  },

  watch: {
    temEquipamento(val) {
      this.contrato.carros = val ? 1 : 0;
      this.emitUpdate();
    },
    "contrato.fog": {
      immediate: true,
      handler(val) {
        this.fogAtivo = !!val;
      },
    },
    "contrato.ubv": {
      immediate: true,
      handler(val) {
        this.ubvAtivo = !!val;
      },
    },
    "contrato.escada": {
      immediate: true,
      handler(val) {
        this.escadaAtivo = !!val;
      },
    },
  },

  methods: {
    onFogChange(val) {
      this.contrato.fog = val ? 1 : 0;
      this.emitUpdate();
    },
    onUbvChange(val) {
      this.contrato.ubv = val ? 1 : 0;
      this.emitUpdate();
    },
    onEscadaChange(val) {
      this.contrato.escada = val ? 1 : 0;
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit("update", { ...this.contrato });
    },
  },
};
</script>

<style scoped>
/* Layout principal: lado a lado em telas grandes */
.prospeccao-extras-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1rem;
  padding: 0.5rem 1rem;
}

/* Bloco de switches */
.prospeccao-extras-controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  flex-shrink: 0;
}

/* Divisor vertical entre grupos */
.prospeccao-divider {
  width: 1px;
  align-self: stretch;
  background-color: #e0e0e0;
  margin: 0 0.5rem;
}

/* Legenda ocupa o espaço restante */
.prospeccao-extras-legenda {
  flex: 1;
  min-width: 0;
}

/* Oculta legenda em telas menores que 1400px */
@media (max-width: 1399px) {
  .legenda-hidden-sm {
    display: none !important;
  }
}

/* Telas médias (641px–900px): empilha controls e legenda */
@media (max-width: 900px) {
  .prospeccao-extras-wrapper {
    flex-direction: column;
  }
  .prospeccao-extras-controls {
    width: 100%;
    flex-wrap: wrap;
    gap: 1.5rem;
  }
  .prospeccao-extras-legenda {
    width: 100%;
  }
}

/* Telas pequenas (≤640px): switches também em coluna */
@media (max-width: 640px) {
  .prospeccao-extras-controls {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  .prospeccao-divider {
    display: none;
  }
}
</style>
